import src from "IMAGE";
export default { src, width: 286, height: 45, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ANnj7N3g6fDI9cvFzO3aycaIv+DHib/gy9/h4cjo1snbuL4aWvwrdKIAAAAASUVORK5CYII="};
